import { render, staticRenderFns } from "./TypeAndAmountFields.vue?vue&type=template&id=b6869a52&scoped=true&"
import script from "./TypeAndAmountFields.vue?vue&type=script&lang=js&"
export * from "./TypeAndAmountFields.vue?vue&type=script&lang=js&"
import style0 from "./TypeAndAmountFields.vue?vue&type=style&index=0&id=b6869a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6869a52",
  null
  
)

export default component.exports